import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { SalariesSettingsVM } from '../../Structure/ViewModels/Admin/SalariesSettingsVM'

const SalarysSettings = () => {
  const [vm,setVm] = useState<{viewModel:SalariesSettingsVM}>({viewModel:new SalariesSettingsVM()})
  const control = vm.viewModel
  useEffect(()=>{
    control.subscribeUpdate(setVm)
    control.getData()
  },[])

  return (
    <Container>
      <Row className=' justify-content-center h-100'>
        <Col lg={6} className='d-flex flex-column justify-content-center'>
          <Row className='py-3'>
            <Col md={6}>
              <h5>التارجت</h5>
            </Col>
            <Col md={6}>
              <input type="text" className='input-field' value={control.Target} onChange={a=>control.Target=a.target.value} />
            </Col>
          </Row>
          <Row className='py-3'>
            <Col md={6}>
              <h5>الخصومات</h5>
            </Col>
            <Col md={6}>
              <input type="text" className='input-field' value={control.Cuts} onChange={a=>control.Cuts=a.target.value} />
            </Col>
          </Row>
          <Row className='py-3'>
            <Col md={6}>
              <h5>البونص</h5>
            </Col>
            <Col md={6}>
              <input type="text" className='input-field' value={control.Bounses} onChange={a=>control.Bounses=a.target.value} />
            </Col>
          </Row>
          <Row className='py-4 justify-content-center'>
            <Col md={6}>
              <button className='button-II btn-cl-I px-5 py-2' onClick={()=>control.save()}>حفظ</button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default SalarysSettings
